import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as typography from "@styles/typography.module.css";
import classNames from "classnames";
import * as styles from "./contactField.module.css";
const ContactField = ({ Icon, title, description, }) => {
    return (_jsxs("div", { className: styles.contactFieldContainer, children: [_jsxs("div", { className: styles.contactFieldHeader, children: [_jsx(Icon, {}), _jsx("p", { className: classNames(typography.bodySmall, typography.bold), children: title })] }), _jsx("p", { className: typography.bodySmall, children: description })] }));
};
export default ContactField;
